import { Link } from 'react-router-dom';

import { fmtDate, fmtDateCompact } from '@/lib/format';
import { useI18n } from '@/providers/i18n';
import type { MoctEvent } from '@/types';

import styles from './EventRow.module.css';

interface EventRowProps {
  event: MoctEvent;
}

type RowState = 'available' | 'low' | 'soldout';

function rowStateFrom(state: MoctEvent['state']): RowState {
  if (state === 'low') return 'low';
  if (state === 'sold-out') return 'soldout';
  return 'available';
}

export default function EventRow({ event }: EventRowProps) {
  const { t, lang } = useI18n();
  const dd = fmtDate(event.date, lang);
  const state = rowStateFrom(event.state);
  const stateLabel =
    event.state === 'low'
      ? t('state.low')
      : event.state === 'sold-out'
        ? t('state.soldout')
        : t('state.available');
  const headliners = Object.values(event.lineup).flat().slice(0, 5);
  const venueLabel = event.venue === 'hayfilm' ? 'HAYFILM' : 'AYRARAT';

  return (
    <Link to={`/events/${event.id}`} className={styles.root}>
      <div className={styles.date}>
        <span className={styles.dateDay}>{dd.day}</span>
        <span className={styles.dateMonth}>
          {dd.month} {dd.year}
        </span>
      </div>
      <div className={styles.titleW}>
        <div className={styles.title}>{event.title}</div>
        <div className={styles.sub}>
          {event.code} · {fmtDateCompact(event.date)} · {venueLabel}
        </div>
      </div>
      <div className={styles.lineupMini}>
        {headliners.map((a, i) => (
          <span key={`${event.id}-${i}-${a}`}>{a}</span>
        ))}
      </div>
      <div className={styles.venue}>
        {event.doors} → {event.close}
      </div>
      <div className={styles.state} data-state={state}>
        {stateLabel}
      </div>
      <div className={styles.arrow}>{t('cta.details')}</div>
    </Link>
  );
}
